import { Component, OnInit } from "@angular/core";

@Component({
  selector: "checkout-layout",
  templateUrl: "./checkout-layout.component.html",
  styleUrls: ["./checkout-layout.component.scss"],
})
export class CheckoutLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
